export default "/images/raport-new.svg?4774ecdbd349e55f774fb11b64e906f8";